export class SelectCompany {
    id: string;
    text: string;

    constructor(id: string, text: string) {
        this.id = id;
        this.text = text;
    }
}



// WEBPACK FOOTER //
// ./src/app/management/components/impersonate/selectCompany.ts